import { ConfigurationChangeService } from '@/services/ConfigurationChangeService';
import { ConfigurationChangeModel, RootState, StoreConstants, ConfigurationChangeState } from '@/types';
import { ActionTree } from 'vuex';

export const actions: ActionTree<ConfigurationChangeState, RootState> = {
  async [StoreConstants.ConfigurationChange.Actions.BeginChange]({ commit, dispatch }, { controllerPath, configurationChange }) {
    try {
      commit(StoreConstants.ConfigurationChange.Mutations.SetIsLoading, true);
      const result = await ConfigurationChangeService.beginChangeAsync(controllerPath, configurationChange);
      commit(StoreConstants.ConfigurationChange.Mutations.SetConfigurationChange, result);
      commit(StoreConstants.ConfigurationChange.Mutations.SetIsLoading, false);
    } catch (error) {
      dispatch(StoreConstants.ConfigurationChange.Actions.GetChangeWithErrorPage, controllerPath);
    }
  },
  async [StoreConstants.ConfigurationChange.Actions.EndChange]({ commit, dispatch, getters }, controllerPath: string) {
    try {
      commit(StoreConstants.ConfigurationChange.Mutations.SetIsLoading, true);
      const changeId: number = getters[StoreConstants.ConfigurationChange.Getters.ConfigurationChange].id;
      const result = await ConfigurationChangeService.endChangeAsync(controllerPath, changeId);
      commit(StoreConstants.ConfigurationChange.Mutations.SetConfigurationChange, result);
      commit(StoreConstants.ConfigurationChange.Mutations.SetIsLoading, false);
    } catch (error) {
      dispatch(StoreConstants.ConfigurationChange.Actions.GetChangeWithErrorPage, controllerPath);
    }
  },
  // tslint:disable-next-line:max-line-length
  async [StoreConstants.ConfigurationChange.Actions.GetChangeWithErrorPage]({ commit, getters }, controllerPath: string) {
    try {
      commit(StoreConstants.ConfigurationChange.Mutations.SetIsLoading, true);
      const result = await ConfigurationChangeService.getChangeWithErrorPageAsync(controllerPath);
      commit(StoreConstants.ConfigurationChange.Mutations.SetConfigurationChange, result);
    } catch (error) {
      commit(StoreConstants.ConfigurationChange.Mutations.SetConfigurationChange, {} as ConfigurationChangeModel);
    } finally {
      commit(StoreConstants.ConfigurationChange.Mutations.SetIsLoading, false);
    }
  }
};
